// Define the webhook URL
const WEBHOOK_URL = import.meta.env.VITE_CHAT_WEBHOOK_URL || "https://n8n.tools.gebeya.io/webhook/2d59a2f2-c3b4-4050-b5dc-6355cdf392eb";

// Exported configuration for the chatbot
export const CHAT_CONFIG = {
  API_URL: WEBHOOK_URL,
  MAX_MESSAGES: 100, // Maximum number of messages to store in history
  STORAGE_KEY: 'jitume-conversations',
  SESSION_ID_KEY: 'jitume_session_id',
  AUTH_KEY: 'sb-auth'
};

// Log the configured webhook URL for debugging
console.log("Configured webhook URL:", CHAT_CONFIG.API_URL); 